import { api } from '@/api'

export interface CreateServicePayload {
  category_ids: string[]
  provider_id: string
  name: string
  slug: string
  service_type_id: string
  short_description: string
  description: string
  logo_url?: string | null
  is_featured: boolean
  popular_sort_order?: number | null
  featured_sort_order?: number | null
  is_active: boolean
  sort_order: number
  page_title?: string
  page_description?: string
  page_status?: boolean
  seo_title?: string
  seo_description?: string
  plans: {
    name: string
    slug?: string
    description: string | null
    duration_days: number | null
    is_popular?: boolean
    is_active: boolean
    sort_order: number
    prices: {
      region_id?: string | null
      currency_id?: string
      pricing_type?: string
      amount?: string
      unit?: string | null
      billing_period?: string
      min_quantity?: number
      max_quantity?: number | null
      is_starting_from?: boolean
      is_official?: boolean
    }[]
  }[]
  order_type_ids: string[]
}

export function createServiceAction(payload: CreateServicePayload) {
  return api.v2.post('/services', payload as unknown as Record<string, unknown>)
}
